import { render, staticRenderFns } from "./teacher_list.vue?vue&type=template&id=b529064a&scoped=true"
import script from "./teacher_list.vue?vue&type=script&lang=js"
export * from "./teacher_list.vue?vue&type=script&lang=js"
import style0 from "./teacher_list.vue?vue&type=style&index=0&id=b529064a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b529064a",
  null
  
)

export default component.exports